import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron",
  "use": "chevron-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"chevron\">\r\n<path d=\"M5 7L10 12L15 7\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"square\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol